import { render, staticRenderFns } from "./GiftCompanyForm.vue?vue&type=template&id=d45f5a52&"
import script from "./GiftCompanyForm.vue?vue&type=script&lang=js&"
export * from "./GiftCompanyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d45f5a52')) {
      api.createRecord('d45f5a52', component.options)
    } else {
      api.reload('d45f5a52', component.options)
    }
    module.hot.accept("./GiftCompanyForm.vue?vue&type=template&id=d45f5a52&", function () {
      api.rerender('d45f5a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/auth/modules/GiftCompanyForm.vue"
export default component.exports